import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { PRODUCT_IMAGE } from '../lib/constants';
const nombres = ['Marcela G.', 'Jorge I.', 'Valeria S.', 'Diego P.', 'Silvia R.', 'Gustavo M.', 'Andrea Q.', 'Roberto V.', 'Lucía B.', 'Fernando A.', 'Patricia L.', 'Claudio F.'];
const ciudades = ['Rosario, Santa Fe', 'La Plata, Bs. As.', 'Córdoba Capital', 'Mendoza', 'Neuquén', 'Salta', 'Mar del Plata', 'San Miguel de Tucumán', 'Bahía Blanca', 'Resistencia, Chaco', 'Posadas, Misiones', 'Río Cuarto, Córdoba'];
const pick = <T,>(arr: T[]) => arr[Math.floor(Math.random() * arr.length)];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    nombre: nombres[0],
    ciudad: ciudades[0],
    hace: 3
  });
  useEffect(() => {
    let hideTimer: number;
    const show = () => {
      setData({
        nombre: pick(nombres),
        ciudad: pick(ciudades),
        hace: Math.floor(Math.random() * 14) + 2
      });
      setVisible(true);
      hideTimer = window.setTimeout(() => setVisible(false), 6000);
    };
    const first = window.setTimeout(show, 6000);
    const loop = window.setInterval(show, 25000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, []);
  return <AnimatePresence data-id="element-151" data-mp="n8y4wb1r6tcl">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-24 left-3 right-3 z-40" role="status" data-id="element-152" data-mp="i93f6atps9t4">
          <div className="flex items-center gap-3 rounded-xl border border-teal-300/25 bg-[#0b2b2e]/95 p-2.5 shadow-2xl backdrop-blur" data-id="element-153" data-mp="23kbp2z3k0x6j">
            <img src={PRODUCT_IMAGE} alt="" aria-hidden="true" className="h-11 w-11 flex-none rounded-lg object-cover" data-id="element-154" data-mp="2aqntuvbyk16x" />
            <div className="min-w-0 flex-1" data-id="element-155" data-mp="2kniov490vjgg">
              <p className="flex items-center gap-1 text-[12.5px] font-semibold leading-tight text-white" data-id="element-156" data-mp="2pmdiz2cfwufv">
                <CheckCircle2Icon className="h-3.5 w-3.5 flex-none text-emerald-400" aria-hidden="true" data-id="element-157" data-mp="1ryv1920swhzq" />
                {data.nombre} compró este libro digital
              </p>
              <p className="truncate text-[11px] text-teal-200/70" data-id="element-158" data-mp="21uoobfc5btvr">
                {data.ciudad} · hace {data.hace} minutos
              </p>
            </div>
            <button type="button" onClick={() => setVisible(false)} aria-label="Cerrar aviso" className="flex-none rounded-md p-1 text-teal-200/60 hover:text-white" data-id="element-159" data-mp="1983wkdrrdfro">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-160" data-mp="3rgex01gzxo12" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}